export default __webpack_public_path__ + "static/media/react.7927890c.jpg";